<template>
  <view-container
    class="view-product-register-coproducer"
    header
    :breadcrumbs="breadcrumbs"
  >
    <template #header>
      <product-dropdown v-if="product" :product="product" />
    </template>
    <!-- <div class="row"> -->
    <!-- <div class="col-lg-4">
        <steps
          :step="currentStep"
          :names="['Sobre o coprodutor', 'Verificação']"
        />
      </div> -->
    <!-- <div class="col-lg-8"> -->
    <register-coproducer-step-01
      :form="form"
      :errors="errors"
      :loading="loading"
      @next="next()"
      @submit="onSubmit()"
    />
    <!-- <register-coproducer-step-02
          v-else
          :form="form"
          :errors="errors"
          @previous="previous()"
          @submit="onSubmit()"
        /> -->
    <!-- </div> -->
    <!-- </div> -->
  </view-container>
</template>
<script>
// import RegisterCoproducerStep02 from "@/components/product/coproducer/RegisterCoproducerStep02.vue";
import RegisterCoproducerStep01 from "@/components/product/coproducer/RegisterCoproducerStep01.vue";
import ProductDropdown from "@/components/product/ProductDropdown";
import ViewContainer from "@/components/ViewContainer";
import { get_error_msg } from "@/functions/helpers";
// import Steps from "@/components/product/Steps";
import { formFields } from "@/functions/helpers";
import moment from "moment";
import { mapState } from "vuex";

export default {
  components: {
    RegisterCoproducerStep01,
    ProductDropdown,
    ViewContainer
  },
  data() {
    return {
      // currentStep: 1,
      loading: false,
      ...formFields(
        [
          "email",
          "qty_months",
          "tax_product",
          "payment_recurrence",
          "contract_time"
        ],
        {
          accepted_terms: false,
          payment_recurrence: true,
          contract_time: null,
          qty_months: null
        }
      )
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        {
          link: "product-coproducers",
          title: "Coprodutores"
        },
        {
          title: "Cadastrar coprodutor"
        }
      ];
    }
  },
  methods: {
    // previous() {
    //   this.currentStep -= 1;
    // },
    // next() {
    //   this.currentStep += 1;
    // },
    async submitCoProducer() {
      return this.$store
        .dispatch("user/postCoProducer", this.form.email)
        .catch(error => {
          this.errors = error.response.data;
        });
    },
    async submitCoProducerProduct(co_producer_id) {
      const { payment_recurrence, tax_product, email } = this.form;
      const contract_time =
        this.form.qty_months === -1
          ? null
          : moment()
              .add(this.form.qty_months, "months")
              .format("YYYY-MM-DD");

      return this.$store.dispatch("user/postCoProducerProduct", {
        co_producer_id,
        product_id: this.$route.params.id,
        contract_time,
        payment_recurrence,
        tax_product
      });
    },
    async onSubmit() {
      if (this.loading) return;

      this.loading = true;
      try {
        if (Number(this.form.tax_product) >= 100) {
          this.$message.warning(
            "A porcentagem de comissão do coprodutor deve ser menor ou igual a 99"
          );
          return;
        }

        const { data: coproducer } = await this.submitCoProducer();

        await this.submitCoProducerProduct(coproducer.id);

        this.$message.success("Coprodutor cadastrado com sucesso!");

        this.$router.push({
          name: "product-coproducers",
          params: {
            id: this.$route.params.id
          }
        });
      } catch (error) {
        let msg = get_error_msg(
          error.response.data,
          {
            email: "E-mail",
            qty_months: "Tempo de contrato",
            tax_product: "Porcentagem das comissões",
            payment_recurrence: "Checkbox de recorrência",
            contract_time: "Tempo de contrato"
          },
          "Não foi possível cadastrar o coprodutor"
        );
        this.$message.error(msg);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.view-product-register-coproducer {
  h4 {
    font-size: 24px !important;
  }
}
</style>
